<template>
  <div class="car_model">
    <div class="search_box">
      <div class="flexbox">
        <van-icon name="search" color="#9B9B9B" />
        <input v-model="brandName" type="text" class="inputbox" placeholder="请输入品牌型号">
      </div>
      <span class="soutext" @click="onSearch">搜索</span>
    </div>
    <div v-if="!isShow" class="container">
      <img :src="imgUrl" alt>
      <p>很遗憾没有找到你的车型</p>
      <button @click="back">
        返回核对信息
      </button>
    </div>
    <div v-if="isShow" class="other-container">
      <div class="wrap">
        <div v-for="(item,index) in carModelList" :key="index" class="type-content" @click="getIndex(index)">
          <van-radio-group v-model="raiod" style="float:left;margin-right:10px">
            <van-radio :name="index" checked-color="#F29600" />
          </van-radio-group>
          <div class="info-content">
            <h1>{{ item.modelName }}</h1>
            <div class="info-li">
              <li>排量:{{ item.exhaustCapacity }}ml</li>&nbsp;
              <li>{{ item.seatCount }}座</li>
            </div>
            <div class="info-li">
              新车购置价：{{ item.purchasePrice }} 车型种类：{{ item.importFlag }}
            </div>
            <div class="info-li">
              行业车型编码：{{ item.platVehicleCode }}
            </div>
            <div class="info-li">
              {{ item.productStatus }}（类比价：{{ item.kindredPrice }}）
            </div>
            <div class="info-li">
              车型编码：{{ item.modelCode }}
            </div>
          </div>
        </div>
      </div>
      <div v-show="goNextBtn" class="commit-content">
        <button @click="nevigateTo">
          确定
        </button>
        <p>如果没有正确车型，请返回核实品牌型号与车架号</p>
      </div>
    </div>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import { Toast } from 'vant'
import Loading from '@/components/Loadings/Loading'
import { removeWatermark, setWaterMark } from '../../../watermark'
export default {
  components: {
    Loading
  },
  data() {
    return {
      raiod: -1,
      goNextBtn: true,
      switchs: false,
      carModelList: [],
      queryParams: {},
      brandName: '',
      imgUrl: api.imgAllUrl + '/sales190709.png',
      isShow: true,
      checkNo: '',
      isPop: false, // 弹窗
      orderId: '', // 订单id
      cInfo: {}

    }
  },
  activated() {
    this.$store.commit('set_showStep', false)
    this.carModelList = []
    this.queryParams = this.$route.params
    if (!checkFormat.isEmpty(this.$store.state.motorOrderId)) {
      this.orderId = this.$store.state.motorOrderId
    }
    this.brandName = this.$route.params.brandName.replace(/[\u4e00-\u9fa5]/g, '')
    console.log(this.queryParams)
    this.isShow = true
    this.raiod = -1
    this.getQueryMotorModelDto()
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  deactivated() {
    Toast.clear()
    this.goNextBtn = true
    removeWatermark()
  },
  destroyed() {
    this.goNextBtn = true
  },

  methods: {
    onSearch() {
      this.getQueryMotorModelDto()
    },
    getQueryMotorModelDto() {
      // DP_WXMP/DP_OWXPA
      this.switchs = true
      this.carModelList = []
      const obj = {
        brandName: this.brandName,
        comCode: this.queryParams.comCode,
        certificateDate: '',
        engineNo: '',
        enrollDate: '',
        licenseNo: '',
        orderId: this.orderId,
        vINNo: '',
        productCode: 'motor_product',
        productName: '摩托车险',
        terminalId: 'H5',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        insuranceSign: '0',
        checkNo: '',
        checkCode: '',
        modelCode: '',
        licenseKindCode: '',
        orderNo: this.queryParams.orderNo || ''
        // operatorCode: process.env.ENV_CONFIG === 'dev' ? '241003245' : '241013036',
        // userComCode: process.env.ENV_CONFIG === 'dev' ? '241003245' : '2410102606'
        // comCode:process.env.ENV_CONFIG=='dev' ? '2410100601' : '410000',
      }
      this.$http.post(api.queryVehicleModel, obj).then(res => {
        if (res.data.rtnCode === '0002') {
          if (res.data.checkCode == null || res.data.checkNo == null) {
            this.isShow = false
          } else {
            // this.yzm = "data:image/jpeg;base64," + res.data.checkCode;
            this.checkNo = res.data.checkNo
            this.orderId = res.data.orderId
            this.$store.commit('set_motorOrderId', this.orderId)
            this.orderNo = res.data.orderNo
            this.$store.commit('set_orderNo', this.orderNo)
            // this.yzmNum = "";
            // this.isPop = true;
          }
          Toast.clear()
        } else if (res.data.rtnCode === '0000' || res.data.rtnCode === '011' && res.data.orderId !== '') {
          this.orderId = res.data.orderId
          this.$store.commit('set_motorOrderId', this.orderId)
          if (Array.isArray(res.data.resultObj) && res.data.resultObj.length > 0) {
            this.orderNo = res.data.orderNo
            this.$store.commit('set_orderNo', this.orderNo)
            res.data.resultObj.forEach(item => {
              this.carModelList.push(item)
            })
            this.isShow = true
          } else {
            this.isShow = false
          }
          Toast.clear()
        } else {
          Toast.clear()
          this.$toast(res.data.rtnMsg)
          this.isShow = false
        }
        this.switchs = false
      }).catch(error => {
        this.switchs = false
        console.log(error)
      })
    },
    getIndex(index) {
      this.raiod = index
    },
    back() {
      this.$router.go(-1)
    },
    nevigateTo() {
      // 如果为空，则为新订单
      if (checkFormat.isEmpty(this.$store.state.motorOrderId)) {
        this.$store.commit('set_motorOrderId', this.orderId)
      }
      const obj = this.carModelList[this.raiod]
      this.$router.replace({
        name: 'BaseInfo',
        params: {
          result: obj,
          orderId: this.orderId,
          orderNo: this.orderNo
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './carModel.scss';
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/baseInfo/components/carModelList.vue